// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1kNVd","file":"styles_file__1tYfw"};